module.exports = __webpack_public_path__ + "img/programme9.b387331c.png";